import React from 'react';
import { Grid } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Section, InfoField, formatDateTime } from '../ViewPatientDialog.utils';

export default function MetaInfoTab({ patient }) {
  const fiche = patient?.fiche_patient;

  return (
    <Section icon={<AccessTimeIcon />} title="Informations du dossier" subtitle="Informations techniques et dates de suivi">
      <Grid container spacing={2}>
        <InfoField label="ID profil patient" value={patient.id_patient_profile} />
        <InfoField label="ID client" value={patient.client_id} />
        <InfoField label="ID fiche patient" value={fiche?.id_fiche_patient} />
        <InfoField label="Création du profil" value={formatDateTime(patient.created_at)} />
        <InfoField label="Dernière modification du profil" value={formatDateTime(patient.updated_at)} />
        <InfoField label="Création de la fiche" value={formatDateTime(fiche?.created_at)} />
        <InfoField label="Dernière modification de la fiche" value={formatDateTime(fiche?.updated_at)} />
      </Grid>
    </Section>
  );
}